module.exports = __webpack_public_path__ + "img/q_other3.2c43d1e0.png";